import MRAditionalOptions from 'components/summary/MRAditionalOptions/component';

export default MRAditionalOptions;
